import React from 'react';
import './Home.css';
import { useLanguage } from '../context/LanguageContext';
import Icon from '../components/Icon';
import HoliColorEffect from '../components/HoliColorEffect';
import { useRef } from 'react';

const Home = () => {
  const { t } = useLanguage();
  const heroRef = useRef(null);
  const getDarshanStatus = () => {
    const now = new Date();
    const hour = now.getHours();
    const minutes = now.getMinutes();
    const currentTime = hour * 60 + minutes;

    const morningStart = 5 * 60; // 5:00 AM
    const morningEnd = 11 * 60;  // 11:00 AM
    const eveningStart = 16 * 60; // 4:00 PM
    const eveningEnd = 21 * 60;   // 9:00 PM

    if (currentTime >= morningStart && currentTime < morningEnd) {
      return {
        isOpen: true,
        message: t('home.darshanOpenUntil', { time: '11:00 AM' }),
        class: 'open'
      };
    } else if (currentTime >= eveningStart && currentTime < eveningEnd) {
      return {
        isOpen: true,
        message: t('home.darshanOpenUntil', { time: '9:00 PM' }),
        class: 'open'
      };
    } else {
      let nextTime = '5:00 AM';
      if (currentTime < eveningStart && currentTime >= morningEnd) {
        nextTime = '4:00 PM';
      }
      return {
        isOpen: false,
        message: t('home.nextDarshanAt', { time: nextTime }),
        class: 'closed'
      };
    }
  };

  const status = getDarshanStatus();

  return (
    <div className="home-page">
      <section className="hero-section">
        {/* ── Native Art Direction Background ── */}
        <picture className="hero-bg-container" ref={heroRef}>
          <source
            media="(max-width: 768px)"
            srcSet="/Assets/home/devmobile4.png"
          />
          <img
            src="/Assets/home/dev2.jpg"
            alt={t('templeTitle')}
            className="hero-bg-img"
            fetchPriority="high"
            loading="eager"
          />
          <HoliColorEffect containerRef={heroRef} />

          {/* Mobile Timings Overlay */}
          <div className="hero-mobile-timings-overlay mobile-only">
            {t('home.morning')}  <br />{t('home.evening')}
          </div>
        </picture>

        {/* ── Visual Polish Overlay ── */}
        <div className="hero-vignette-overlay" />

        <div className="hero-wrapper">
          <div className="hero-content-center">
            {/* <h1 className="hero-title-main">
              {t('pageContent.heroTitleSentence')}
            </h1> */}
          </div>
        </div>

        {/* ── Mobile Darshan Timings Pill ── */}
        <div className="hero-mobile-timings">
          <div className={`timing-pill ${status.class}`}>
            <span className="dot"></span>
            <span className="status-text">{status.message}</span>
          </div>
        </div>
      </section>


      <section className="running-banner">
        <div className="banner-content">
          <div className="marquee">
            <span className="marquee-text">
              <span className="star">★</span> {t('pageContent.welcomeTitle')} : {t('home.marqueeMessage')} <span className="star">★</span>
            </span>
            <span className="marquee-text">
              <span className="star">★</span> {t('pageContent.welcomeTitle')} : {t('home.marqueeMessage')} <span className="star">★</span>
            </span>
          </div>
        </div>
      </section>

      <section className="welcome-section">
        <div className="container">
          <div className="welcome-card">
            <div className="welcome-badge">{t('pageContent.welcomeTitle')}</div>
            <h2 className="welcome-title">{t('pageContent.mainTitle')}</h2>
            <div className="welcome-divider"></div>
            <p className="welcome-text">{t('pageContent.welcomeText')}</p>
          </div>
        </div>
      </section>

      <section className="temple-showcase" id="showcase">
        <div className="container">
          <h2 className="section-title">{t('home.showcase.title')}</h2>
          <div className="divider"></div>
          <div className="showcase-grid">
            <div className="showcase-image">
              <img
                src="Assets/home/temple-architecture.jpg"
                alt={t('home.showcase.overlayText')}
                className="temple-image"
              />
              <div className="image-overlay">
                <p className="overlay-text">{t('home.showcase.overlayText')}</p>
              </div>
            </div>
            <div className="showcase-info">
              <div className="info-card">
                <div className="info-card-header">
                  <div className="info-icon"><Icon name="temple" /></div>
                  <h3>{t('home.showcase.magnificenttitle')}</h3>
                </div>
                <p>{t('home.showcase.magnificentText')}</p>
              </div>
              <div className="info-card">
                <div className="info-card-header">
                  <div className="info-icon"><Icon name="lamp" /></div>
                  <h3>{t('home.showcase.dailyPoojaTitle')}</h3>
                </div>
                <p>{t('home.showcase.dailyPoojaText')}</p>
              </div>
              <div className="info-card">
                <div className="info-card-header">
                  <div className="info-icon"><Icon name="prayer" /></div>
                  <h3>{t('home.showcase.spiritualityTitle')}</h3>
                </div>
                <p>{t('home.showcase.spiritualityText')}</p>
              </div>
              <div className="info-card">
                <div className="info-card-header">
                  <div className="info-icon"><Icon name="festival" /></div>
                  <h3>{t('home.showcase.festivalTraditionTitle')}</h3>
                </div>
                <p>{t('home.showcase.festivalTraditionText')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>



      <section className="facts-section" id="facts">
        <div className="container">
          <h2 className="section-title">{t('home.facts.title')}</h2>
          <div className="divider"></div>
          <div className="facts-grid">
            <div className="fact-card visible">
              <div className="fact-icon"><Icon name="clock" /></div>
              <h3>{t('home.facts.darshanTitle')}</h3>
              <p>{t('home.facts.darshanText')}</p>
            </div>
            <div className="fact-card visible">
              <div className="fact-icon"><Icon name="location" /></div>
              <h3>{t('home.facts.locationTitle')}</h3>
              <p>{t('home.facts.locationText')}</p>
            </div>
            <div className="fact-card visible">
              <div className="fact-icon"><Icon name="car" /></div>
              <h3>{t('home.facts.reachTitle')}</h3>
              <p>{t('home.facts.reachText')}</p>
            </div>
            <div className="fact-card visible">
              <div className="fact-icon"><Icon name="phone" /></div>
              <h3>{t('home.facts.contactTitle')}</h3>
              <p>{t('home.facts.contactText')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="events-section" id="events">
        <div className="container">
          <h2 className="section-title">{t('home.festivals.title')}</h2>
          <div className="divider"></div>
          <div className="events-grid">
            <div className="event-card visible">
              <div className="event-date">{t('home.festivals.annualYatraDate')}</div>
              <h3>{t('home.festivals.annualYatraTitle')}</h3>
              <p>{t('home.festivals.annualYatraText')}</p>
            </div>
            <div className="event-card visible">
              <div className="event-date">{t('home.festivals.shravanMonth')}</div>
              <h3>{t('home.festivals.shravanTitle')}</h3>
              <p>{t('home.festivals.shravanText')}</p>
            </div>
            <div className="event-card visible">
              <div className="event-date">{t('home.festivals.everyMonth')}</div>
              <h3>{t('home.festivals.poornimaTitle')}</h3>
              <p>{t('home.festivals.poornimaText')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="facilities-section" id="facilities">
        <div className="container">
          <h2 className="section-title">{t('home.facilities.title')}</h2>
          <div className="divider"></div>
          <div className="facilities-grid">
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="car" /></div>
              <h3>{t('home.facilities.parkingTitle')}</h3>
              <p>{t('home.facilities.parkingText')}</p>
            </div>
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="restroom" /></div>
              <h3>{t('home.facilities.restroomTitle')}</h3>
              <p>{t('home.facilities.restroomText')}</p>
            </div>
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="water" /></div>
              <h3>{t('home.facilities.waterTitle')}</h3>
              <p>{t('home.facilities.waterText')}</p>
            </div>
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="food" /></div>
              <h3>{t('home.facilities.prasadTitle')}</h3>
              <p>{t('home.facilities.prasadText')}</p>
            </div>
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="accessibility" /></div>
              <h3>{t('home.facilities.seniorTitle')}</h3>
              <p>{t('home.facilities.seniorText')}</p>
            </div>
            <div className="facility-card visible">
              <div className="facility-icon"><Icon name="bag" /></div>
              <h3>{t('home.facilities.materialTitle')}</h3>
              <p>{t('home.facilities.materialText')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="reach-section" id="reach">
        <div className="container">
          <h2 className="section-title">{t('home.reach.title')}</h2>
          <div className="divider"></div>
          <div className="reach-content">
            <div className="reach-card">
              <div className="reach-icon"><Icon name="train" /></div>
              <h3>{t('home.reach.railwayTitle')}</h3>
              <p>
                {t('home.reach.railwayText')}
              </p>
              <p>
                <strong>{t('home.reach.railwayNote')}</strong>
              </p>
            </div>
            <div className="reach-card">
              <div className="reach-icon"><Icon name="bus" /></div>
              <h3>{t('home.reach.busTitle')}</h3>
              <p>
                {t('home.reach.busText')}
              </p>
              <p>
                <strong>{t('home.reach.busNote')}</strong>
              </p>
            </div>
            <div className="reach-card">
              <div className="reach-icon"><Icon name="car" /></div>
              <h3>{t('home.reach.carTitle')}</h3>
              <p>
                {t('home.reach.carText')}
              </p>
              <p>
                <strong>{t('home.reach.carNote')}</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;